class CustomProductPrice {
    constructor(product, isMain = false) {
        const productWrapperElKey = isMain ? 'product-details-' : 'collection-product-details-';
        //this.language = window.location.pathname.includes('/en/') ? 'en' : 'he';
        this.language = document.documentElement.lang || 'he';
        const dictionary = {
            "en": {
                "atc": "Add to cart",
                "edit_design": "Edit design"
            },
            "he": {
                "atc": "הוסף לסל",
                "edit_design": " ערוך עיצוב"
            }
        };
        this.text = dictionary[this.language];
        this.quantity = 0;
        this.isMain = isMain;
        this.hasDesign = false;
        this.pacdoraData = {
            projectId: null,
            design: null,
            screenshot: null,
            colors: []
        };
        this.product = product;
        this.productId = product.id;
        this.isLogged = window.Shopify?.customerLogged ?? false;
        this.isVariable = product.variants.length > 1;
        this.currentVariantId = product.currentVariantId;
        this.productWrapperEl = document.getElementById(productWrapperElKey + this.productId);
        this.currency = null;
        this.price = this.extractPriceWithoutCurrencyFromPrice(this.product.price);
        this.setPacdoraColor();
        if (this.isMain) {
            this.initBulkBoxes();
            this.createNewPacdoraScene(this.product.pacdoraModelId).then(() => this.addListeners());
        } else {
            this.addListeners();
        }

    }

    addListeners() {
        if (this.isMain) {
            this.addMainProductListeners();
        }
    }

    addMainProductListeners() {
        const submitBtn = this.productWrapperEl.querySelector('#product-add-to-cart');
        const designButton = this.productWrapperEl.querySelector('.design-btn');
        const quantityInput = this.productWrapperEl.querySelector('.quantity__input');

        submitBtn.addEventListener("click", this.addToCart.bind(this));
        if (quantityInput) {
            const existingValue = parseInt(quantityInput.value, 10);
            console.log("found a quantity input, the value is " + existingValue);
            if (!isNaN(existingValue) && existingValue > 0) {
                this.quantity = existingValue;
                this.mainProductAfterUpdateQty(this.quantity);
            } else {
                // If it's empty or invalid, reset the input to the class's default (0)
                quantityInput.value = this.quantity;
            }
            quantityInput.addEventListener('input', (e) => this.handleQuantityChange(e));
            quantityInput.addEventListener('change', (e) => this.handleQuantityChange(e));
        }
        if (designButton) {
            designButton.addEventListener('click', () => this.openDesignBuilder());
        }
    }

    handleQuantityChange(e) {
        const quantity = parseInt(e.target.value, 10) || 0;
        console.log("quantity is "+quantity);
        this.quantity = quantity;
        if (quantity > 0) {
            const minusButton = document.querySelector('button[name="minus"]');
            if (minusButton) {
                minusButton.classList.remove('btn-disable');
            }
        }
        this.mainProductAfterUpdateQty(quantity);
    }

    mainProductAfterUpdateQty(quantity) {
        console.log("mainProductAfterUpdateQty "+ quantity);
        this.selectBulkBoxByQty(quantity, null, (selectedBox) => {
            const price = selectedBox ? Number(quantity * selectedBox.dataset.price).toFixed(2) : '0.00';
            this.updateSubtotalPrice(price);
            this.toggleMainProductAddToCartButtonBySelectedBox(selectedBox);
            this.toggleMainProductQtyMsgBySelectedBox(selectedBox, quantity);
        });
    }

    toggleMainProductAddToCartButtonBySelectedBox(selectedBox) {
        const submitBtn = this.productWrapperEl.querySelector('#product-add-to-cart');
        if (selectedBox) {
            submitBtn.classList.remove('disabled');
            submitBtn.disabled = false;
        } else {
            submitBtn.classList.add('disabled');
            submitBtn.disabled = true;
        }
    }

    toggleMainProductQtyMsgBySelectedBox(selectedBox, quantity) {
        const qtyMsgEl = this.productWrapperEl.querySelector('#mainProductQtyMsg');
        let qtyMsgText = '';
        if (!selectedBox && quantity > 0) {
            const msg = 'Please note: there is a minimum order quantity for this product. You cannot proceed with the purchase using the quantity you selected.';
            qtyMsgText = CustomProductPriceUtils.getTranslations(msg);
        }
        qtyMsgEl.textContent = qtyMsgText;
    }

    initBulkBoxes() {
        if (!this.productWrapperEl) return;
        const bulkBoxes = this.productWrapperEl.querySelectorAll(".bulk-boxes");
        if (bulkBoxes.length === 0) return;
        const bulkOptions = this.getBulkOptions();
        this.fillBulkBoxes(bulkBoxes, bulkOptions);
    }

    getBulkOptions(specificVariant = null) {
        const samplePrice = this.extractPriceWithoutCurrencyFromPrice(this.product.price);
        const bulkOptions = {
            'bulk-box-sample': {
                title: 'Sample Order',
                price: samplePrice
            }
        };
        this.processBulkMetafields(this.product.metafields, bulkOptions);
        const hasProductSampleMetafield = Object.keys(this.product.metafields).some(
            k => k.startsWith('sampl') && !this.isEmptyValue(this.product.metafields[k])
        );
        if (this.isVariable) {
            const currentVariantData = specificVariant ?? this.getCurrentVariantData();
            if (!hasProductSampleMetafield && currentVariantData?.price) {
                bulkOptions['bulk-box-sample'].price = this.extractPriceWithoutCurrencyFromPrice(currentVariantData.price);
            }

            const variantMetafields = this.product['metafields-variants'][currentVariantData.id] || {};
            this.processVariantMetafields(variantMetafields, bulkOptions, hasProductSampleMetafield);
        }

        this.applyProductDiscount(bulkOptions);

        return bulkOptions;
    }

    applyProductDiscount(bulkOptions) {
        const discount = parseFloat(this.product.metafields?.discount_percentage);
        if (isNaN(discount) || discount <= 0) return;
        const multiplier = (100 - discount) / 100;
        Object.values(bulkOptions).forEach(option => {
            if (option.price) {
                option.price = Number(option.price * multiplier).toFixed(2);
            }
        });
    }

    processBulkMetafields(metafields, bulkOptions) {
        for (const [key, value] of Object.entries(metafields)) {
            if (this.isEmptyValue(value)) continue;

            if (key.startsWith('bulk_option_')) {
                this.processBulkOption(key, value, bulkOptions);
            } else if (key.startsWith('sampl')) {
                bulkOptions['bulk-box-sample'].price = this.extractPriceWithoutCurrencyFromPrice(value);
            }
        }
    }

    processVariantMetafields(metafields, bulkOptions, ignoreSamplePrice = false) {
        for (const [key, value] of Object.entries(metafields)) {
            if (this.isEmptyValue(value)) continue;
            if (key.startsWith('bulk_option_')) {
                this.processBulkOption(key, value, bulkOptions, true);
            } else if (key.startsWith('bulk_multiplier')) {
                this.applyBulkMultiplier(value, bulkOptions);
            } else if (key.startsWith('sampl') && !ignoreSamplePrice) {
                bulkOptions['bulk-box-sample'].price = this.extractPriceWithoutCurrencyFromPrice(value);
            }
        }
    }

    processBulkOption(metafieldKey, value, bulkOptions, isVariant = false) {
        const isValueField = metafieldKey.startsWith('bulk_option_value');
        const bulkKey = metafieldKey.replace(isValueField ? 'bulk_option_value_' : 'bulk_option_', '');
        const optionKey = `bulk-box-${bulkKey}`;

        if (!bulkOptions[optionKey]) {
            bulkOptions[optionKey] = {
                title: '',
                price: 0
            };
        }

        if (isValueField) {
            bulkOptions[optionKey].price = this.extractPriceWithoutCurrencyFromPrice(value);
        } else {
            const title = value.replace('pieces', '').trim();
            bulkOptions[optionKey].title = `${title} pieces`;
        }
    }

    applyBulkMultiplier(multiplierValue, bulkOptions) {
        const multiplier = parseFloat(multiplierValue);
        if (isNaN(multiplier)) return;

        Object.entries(bulkOptions).forEach(([key, option]) => {
            if (key !== 'bulk-box-sample' && option.price) {
                option.price = Number(option.price * multiplier).toFixed(2);
            }
        });
    }

    isEmptyValue(value) {
        return value === null || value === undefined || value === '';
    }

    fillBulkBoxes(bulkBoxes, bulkOptions) {//return false;
        bulkBoxes.forEach(bulkBoxGroup => {
            for (const key in bulkOptions) {
                const item = bulkOptions[key];
                const box = bulkBoxGroup.querySelector(`.bulk-box.${key}`);
                const price = box.querySelector(".bulk-box-price");

                if (box) {
                    box.querySelectorAll('.bulk-box-inner').forEach(el => el.remove());

                    let min = 1;
                    let max = key === 'bulk-box-sample' ? 1 : 9999999;
                    const rangeMatch = item.title.match(/(\d+)\s*-\s*(\d+)/);
                    const plusMatch = item.title.match(/(\d+)\s*\+\s*\w*/);
                    if (rangeMatch) {
                        min = rangeMatch[1];
                        max = rangeMatch[2];
                    } else if (plusMatch) {
                        min = plusMatch[1];
                        max = 9999999;
                    }
                    const inner = document.createElement("div");
                    inner.className = "bulk-box-inner";
                    const translation = box.dataset.txt ?? '';
                    const translatedTitle = this.translateBulkOptionTitle(item.title, translation);
                    inner.dataset.option = translatedTitle;
                    inner.dataset.min = min;
                    inner.dataset.max = max;
                    inner.dataset.price = item.price;
                    const formattedPrice = this.getFormattedPrice(item.price);
                    //const formattedPrice = price.innerHTML;
                    inner.innerHTML = `<div class="bulk-box-title">${translatedTitle}</div><div class="bulk-box-price">${formattedPrice}</div>`;
                    box.appendChild(inner);
                }
            }
        });
    }

    translateBulkOptionTitle(bulkOptionTitle, translation) {
        if (bulkOptionTitle === 'Sample Order') {
            return translation || CustomProductPriceUtils.getTranslations('Sample Order');
        } else if (bulkOptionTitle.includes('pieces')) {
            const piecesCount = bulkOptionTitle.replace('pieces', '').trim();
            const processedTranslation = translation || CustomProductPriceUtils.getTranslations('pieces');
            return `<span class="pieces">${piecesCount}</span> ${processedTranslation}`;
        }
    }

    selectBulkBoxByQty(quantity, wrapperEl = null, afterSelectCallback = null) {
        const productWrapperEl = wrapperEl || this.productWrapperEl;
        const bulkBoxes = productWrapperEl.querySelectorAll(".bulk-boxes .bulk-box-inner");
        let selectedBox = null;
        let maxIntervalBox = null;
        bulkBoxes.forEach(box => {
            const min = parseInt(box.dataset.min, 10) || 0;
            const max = parseInt(box.dataset.max, 10) || 0;
            if (quantity >= min && quantity <= max) {
                selectedBox = box;
            }
            if (maxIntervalBox === null || (max > parseInt(maxIntervalBox.dataset.max, 10))) {
                maxIntervalBox = box;
            }
        });

        if (!selectedBox && maxIntervalBox && quantity >= parseInt(maxIntervalBox.dataset.max, 10)) {
            selectedBox = maxIntervalBox;
        }

        if (selectedBox) {
            bulkBoxes.forEach(box => box.closest('.bulk-box')?.classList.remove("selected"));
            selectedBox.closest('.bulk-box')?.classList.add("selected");
            if (afterSelectCallback && typeof afterSelectCallback === 'function') {
                afterSelectCallback(selectedBox);
            }
        } else {
            bulkBoxes.forEach(box => box.closest('.bulk-box')?.classList.remove("selected"));
            if (afterSelectCallback && typeof afterSelectCallback === 'function') {
                afterSelectCallback(null);
            }
        }
    }

    updateSubtotalPrice(price) {
        const formattedPrice = this.getFormattedPrice(price);
        $(".productView-subtotal").html(`<h3 class="money-subtotal">${formattedPrice}</h3>`);
    }

    getCurrentVariantData() {
        return this.product.variants.find(
            (variant) => variant.id === this.currentVariantId
        ) || {};
    }

    getVariantDataById(variantId) {
        return this.product.variants.find(
            (variant) => variant.id === variantId
        ) || {};
    }

    extractPriceWithoutCurrencyFromPrice(price) {
        this.currency = price.replace(/[0-9.,\s]/g, '');
        const priceWithoutCurrency = price.replace(/[^0-9.,]/g, '').replace(',', '.');

        return Number(priceWithoutCurrency).toFixed(2);
    }

    getFormattedPrice(price) {
        return `${this.currency}${price}`;
    }

    onVariantChange(currentVariant) {
        this.currentVariantId = currentVariant.id;
        this.initBulkBoxes();
        if (this.isMain) {
            this.mainProductAfterUpdateQty(this.quantity);
        }
    }

    async onSaveDesign(data) {
        document.body.classList.remove('pacdora-hide-rollers');
        if (!this.productWrapperEl) return;
        const pacdoraInfoBox = await PacdoraPlus.getBoxInfo();
        this.pacdoraData.projectId = pacdoraInfoBox.id;
        this.pacdoraData.screenshot = pacdoraInfoBox.screenshot;
        this.pacdoraData.design = data;
        this.hasDesign = true;
        CustomProductPriceInstances.lastPacdoraModelId = pacdoraInfoBox.id;
        const selectedOptions = Array.isArray(data?.advancedData) ? data.advancedData.map(option => option.selected) : [];
        const currentVariant = this.getVariantByOptions(selectedOptions);
        if (currentVariant) this.currentVariantId = currentVariant.id;

        if (this.isMain) {
            this.selectMainVariantOptions();
            this.productWrapperEl.querySelector('.preview-design-btn').classList.add('show-btn');
            const quantityInput = this.productWrapperEl.querySelector('.quantity__input');
            if (quantityInput) {
                console.log("save design: " + quantityInput.value);
                console.log("save design: " + this.quantity);
                quantityInput.value = this.quantity;
                // 1. Check if the input already has a value
                const existingValue = parseInt(quantityInput.value, 10);
                this.mainProductAfterUpdateQty(this.quantity);
            }else{
                console.log("save design else: " + this.quantity);
                this.mainProductAfterUpdateQty(this.quantity);
            }            
        } else {
            this.quantityCollectionAlert();
        }
    }

    onCancelDesign() {
        document.body.classList.remove('pacdora-hide-rollers');
    }

    selectMainVariantOptions() {
        if (!this.productWrapperEl) return;
        const productOptions = this.product.productOptions;
        const currentVariant = this.getCurrentVariantData();
        if (!currentVariant || !productOptions) return;
        const variantOptions = currentVariant.options || [];
        productOptions.forEach((option, index) => {
            const optionName = option.name;
            const selectedValue = variantOptions[index];
            const escapedValue = selectedValue.replace(/"/g, '\\"');
            const radio = this.productWrapperEl.querySelector(
                `.productView-variants input[type="radio"][name="${optionName}"][value="${escapedValue}"]`
                //`.productView-variants input[type="radio"][name="${optionName}"][value="${selectedValue}"]`
            );
            if (radio) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', {bubbles: true}));
            }
        });
    }

    async addToCart(e) {
        e.preventDefault();
        e.stopPropagation();

        const form = e.target.closest(
            'form[data-type="add-to-cart-form"]'
        );
        const formData = new FormData(form);
        const quantity = formData.get("quantity") || 1;
        await this.addToCartByQty(quantity);
    }

    async addToCartByQty(quantity) {
        const productId = this.productId;
        const variantId = this.currentVariantId;

        if (!this.checkBeforeAddToCartValidation(quantity)) return;

        const designData = await Pacdora.getBoxInfo();

        try {
            CustomProductPriceUtils.showLoadingIndicator();

            const response = await fetch(
                "https://shopify.stockka.com/endpoints/get-temporary-product.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        title: this.getProductTitleFromHTML(),
                        product_id: productId,
                        variant_id: variantId,
                        quantity: quantity,
                        image_url: designData.screenshot,
                        design_id: designData.id,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Error fetching temporary product");
            }

            const data = await response.json();

            if (data.success) {
                this.addTempProductToCart(
                    data.temp_product,
                    quantity,
                    designData
                );
            } else {
                throw new Error(data.message || "Failed to process product");
            }
        } catch (error) {
            console.error("Error:", error);
            CustomProductPriceUtils.hideLoadingIndicator();
            this.showErrorMessage(error.message);
        }
    }

    addTempProductToCart(tempProduct, originalQuantity, designData) {
        var QuantityInPack = "Quantity in pack";
        var DeliveryDate = "Delivery date";
        var Design = "Design";
        if (document.documentElement.lang == "he") {
            QuantityInPack = "מספר יחידות במארז";
            DeliveryDate = "תאריך הגעת המשלוח";
            Design = "העיצוב שלך";
        }

        // Build valid tier quantities from product metafields (only available here on the product page)
        const tierQtys = [];
        if (this.productWrapperEl && this.productWrapperEl.querySelector('.bulk-box-sample')) {
            tierQtys.push(1);
        }
        for (const [key, value] of Object.entries(this.product.metafields || {})) {
            if (key.startsWith('bulk_option_') && !key.startsWith('bulk_option_value_')) {
                const qty = parseInt(value);
                if (!isNaN(qty) && qty > 1) tierQtys.push(qty);
            }
        }
        tierQtys.sort((a, b) => a - b);

        const properties = {
            _design_id: designData.id,
            _original_product_id: tempProduct.original_product_id,
            _original_quantity: originalQuantity,
            _screenshot_url: designData.screenshot,
            _qty_tiers: tierQtys.join(','),
            _product_title: this.getProductTitleFromHTML(),
            [QuantityInPack]: originalQuantity,
            [DeliveryDate]: CustomProductPriceUtils.translateDate(tempProduct.delivery_date),
            [Design]: "https://www.stockka.com/pages/view-modal?projectId=" + designData.id,
        };

        const productOptions = this.product.productOptions;
        const currentVariant = this.getVariantDataById(tempProduct.original_variant_id);
        if (productOptions && productOptions.length > 0 && currentVariant) {
            productOptions.forEach((option, index) => {
                const optionName = option.name;
                const selectedValue = currentVariant.options[index];
                if (selectedValue) {
                    properties[optionName] = selectedValue;
                }
            });
        }

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: tempProduct.variant_id,
                quantity: 1,
                properties,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                CustomProductPriceUtils.hideLoadingIndicator();
                this.updateCartDisplay();
            })
            .catch((error) => {
                console.error("Error adding to cart:", error);
                CustomProductPriceUtils.hideLoadingIndicator();
                this.showErrorMessage("Failed to add to cart");
            });
    }

    getProductTitleFromHTML() {
        if (this.isMain) {
            const titleElement = this.productWrapperEl.querySelector('.productView-title');
            return titleElement ? titleElement.textContent.trim() : '';
        } else {
            const titleElement = this.productWrapperEl.querySelector('.card-title span');
            return titleElement ? titleElement.textContent.trim() : '';
        }
    }

    showErrorMessage(message) {
        alert("Error: " + message);
    }

    updateCartDisplay() {
        Shopify.getCart((cart) => {
            window.halo.updateSidebarCart(cart);
            document.querySelector("a.header__icon--cart").click();
        });
    }

    changeAlertQuantity(event) {
        event.preventDefault();
        const input = event.target.closest(".productView-quantity").querySelector(".alert-quantity");
        let currentValue = parseInt(input.value, 10);
        if (event.target.classList.contains("minus")) {
            currentValue = Math.max(0, currentValue - 1);
        } else if (event.target.classList.contains("plus")) {
            currentValue += 1;
        }
        input.value = currentValue;
        this.quantity = currentValue;
        if (this.isMain) {
            document.getElementById(`quantity-${this.productId}`).value = currentValue;
        } else {
            this.afterChangeAlertQuantity(currentValue);
        }
    }

    afterChangeAlertQuantity(quantity) {
        const alertWrapper = document.querySelector(`.stocka-alert`);
        const alertSubtotal = alertWrapper.querySelector('.stocka-alert .productView-price');
        this.selectBulkBoxByQty(quantity, alertWrapper, (selectedBox) => {
            if (selectedBox) {
                alertSubtotal.textContent = this.getFormattedPrice(Number(quantity * selectedBox.dataset.price).toFixed(2));
            } else {
                alertSubtotal.textContent = this.getFormattedPrice('0.00');
            }
            this.toggleAlertAddToCartButtonBySelectedBox(selectedBox);
            this.toggleAlertQtyMsgBySelectedBox(selectedBox, quantity);
        });
    }

    toggleAlertAddToCartButtonBySelectedBox(selectedBox) {
        const alertSubmitBtn = document.querySelector('.stocka-alert .product-form__submit');
        if (selectedBox) {
            alertSubmitBtn.classList.remove('disabled');
            alertSubmitBtn.disabled = false;
        } else {
            alertSubmitBtn.classList.add('disabled');
            alertSubmitBtn.disabled = true;
        }
    }

    toggleAlertQtyMsgBySelectedBox(selectedBox, quantity) {
        const alertQtyMsgEl = document.querySelector('.stocka-alert .alert-quantity-error');
        let alertQtyMsgText = '';
        if (!selectedBox && quantity > 0) {
            const msg = 'Please note: there is a minimum order quantity for this product. You cannot proceed with the purchase using the quantity you selected.';
            alertQtyMsgText = CustomProductPriceUtils.getTranslations(msg);
        }
        alertQtyMsgEl.textContent = alertQtyMsgText;
    }

    checkBeforeAddToCartValidation(quantity) {
        if (this.hasDesign === false) {
            this.missingDesignAlert();
            return false;
        }
        if (quantity < 1) {
            if (this.isMain) {
                this.quantityAlert();
            } else {
                this.quantityCollectionAlert();
            }
            return false;
        }
        return true;
    }

    missingDesignAlert() {
        const popupHeading = window.ShopifyTranslations?.design_popup_heading || "Don’t forget to design before checkout!";
        const popupButton = window.ShopifyTranslations?.design_popup_button || "Design Now!";
        CustomProductPriceUtils.show.alert({
            content: `<div class="productDesign-Popup">
                    <h4>${popupHeading}</h4>
                    <button type="button" class="btn product-form__submit button button--primary button-text-change" data-value="openBuilder" data-fancybox-close>${popupButton}</button>
                </div>`,
            callback: (value) => {
                if (value === "openBuilder") {
                    if (this.isLogged) {
                        this.openDesignBuilder();
                    } else {
                        setTimeout(function () {
                            document.body.classList.add("auth-sidebar-show");
                        }, 100);
                    }
                }
            },
        });
    }

    quantityAlert() {
        const alertClickQuantityHandler = (event) => {
            if (event.target.matches(".btn-alert-quantity.for-main-product")) {
                this.changeAlertQuantity(event);
            }
        };
        const alertChangeQuantityHandler = (event) => {
            if (event.target.matches(".alert-quantity.for-main-product")) {
                this.changeAlertQuantity(event);
            }
        };
        CustomProductPriceUtils.show.alert({
            content: `<div class="productSelectQt-Popup">
                  <h4>Oh no! seems like you didn’t select the quantity.</h4>
                  <div class="productSelectQt">
                    <div class="productSelectQtTlt">Add quantity first</div>
                    <div class="productSelectQtForm">
                      <form>
                        <div class="productView-group">
                          <div class="productView-groupTop">
                            <div class="quantity__group__wrapper">
                              <div class="productView-quantity quantity__group quantity__group--1 quantity__style--1 clearfix">
                                <div class="quantity__container">
                                  <button type="button" name="minus" class="minus btn-quantity btn-alert-quantity for-main-product"></button>
                                  <input class="form-input quantity__input for-main-product alert-quantity" type="number" name="quantity" min="0" value="${this.quantity}" inputmode="numeric" pattern="[0-9]*">
                                  <button type="button" name="plus" class="plus btn-quantity btn-alert-quantity for-main-product"></button>
                                </div>
                              </div>
                            </div>
                            <div class="productView-action productView-action-2">
                              <div class="product-form__buttons">
                                <button type="button" data-value="addToCart" data-fancybox-close class="product-form__submit button">Add to cart</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>`,
            callback: (value) => {
                document.removeEventListener("click", alertClickQuantityHandler);
                document.removeEventListener("input", alertChangeQuantityHandler);
                if (value === "addToCart") {
                    const quantityInput = document.getElementById(`quantity-${this.productId}`);
                    const quantity = parseInt(quantityInput.value, 10);
                    if (quantity > 0) {
                        this.addToCartByQty(quantity);
                    }
                }
            },
            afterInit: () => {
                document.addEventListener("click", alertClickQuantityHandler);
                document.addEventListener("input", alertChangeQuantityHandler);
            }
        });
    }

    quantityCollectionAlert() {
        const productOptionsHTML = this.getProductOptionsHTML();
        const alertClickQuantityHandler = (event) => {
            if (event.target.matches(".btn-alert-quantity.for-collection-product")) {
                setQuantityError();
                this.changeAlertQuantity(event);
            }
        };
        const alertChangeQuantityHandler = (event) => {
            if (event.target.matches(".alert-quantity.for-collection-product")) {
                setQuantityError();
                this.changeAlertQuantity(event);
            }
        };
        const alertClickAddToCartHandler = (event) => {
            if (event.target.matches(".product-form__submit")) {
                event.preventDefault();
                const quantity = parseInt(this.quantity, 10);
                if (quantity === 0) {
                    setQuantityError("Please select a quantity.");
                } else {
                    $.fancybox.close();
                    this.addToCartByQty(quantity);
                }
            }
        };
        const alertChangeVariableOptionHandler = (event) => {
            if (event.target.matches('.productView-variable-options input[type="radio"]')) {
                const options = document.querySelectorAll('.productView-variable-options input[type="radio"]:checked');
                const selectedOptions = Array.from(options).map(input => input.value);
                const currentVariant = this.getVariantByOptions(selectedOptions);
                if (currentVariant) {
                    this.currentVariantId = currentVariant.id;
                    initBulkBoxes(currentVariant);
                    const quantityInput = document.querySelector(`.stocka-alert .productView-QuickAdd .alert-quantity.for-collection-product`);
                    this.afterChangeAlertQuantity(quantityInput.value);
                }
            }
        };
        const initBulkBoxes = (specificVariant = null) => {
            const bulkBoxes = document.querySelectorAll(".stocka-alert .productView-QuickAdd .bulk-boxes");
            if (bulkBoxes.length === 0) return;
            const bulkOptions = this.getBulkOptions(specificVariant);
            this.fillBulkBoxes(bulkBoxes, bulkOptions);
        }
        const setQuantityError = function (message = '') {
            const errorElement = document.querySelector('.stocka-alert .alert-quantity-error');
            if (errorElement) {
                errorElement.textContent = message;
            }
        }

        CustomProductPriceUtils.show.alert({
            mainClasses: "fc-content stocka-alert white-bg small-padding",
            content: `<div class="productView-QuickAdd">
                  <div class="productView-QuickAdd-wrapper">
                    <div class="productView-top">
                      <div class="productView-media">
                        <img srcset="${this.pacdoraData.screenshot}" data-src="${this.pacdoraData.screenshot}" alt="" sizes="270px" width="1024" height="1024" data-sizes="auto" data-main-image="" data-index="2" data-cursor-image="" class="lazyautosizes ls-is-cached lazyloaded" loading="lazy" src="${this.pacdoraData.screenshot}">
                      </div>
                      <div class="productView-details">
                        <div class="productView-product clearfix">
                          <h1 class="productView-title">
                            <a href="/en/products/${this.product.handle}">${this.product.title}</a>
                          </h1>
                          <div class="productView-price">${this.getFormattedPrice('0.00')}</div>
                          <div class="productView-variable-options">${productOptionsHTML}</div>
                          <div class="productView-options">
                            <div class="bulk-boxes">
                              <div class="bulk-box bulk-box-sample"></div>
                              <div class="bulk-box bulk-box-1"></div>
                              <div class="bulk-box bulk-box-2"></div>
                              <div class="bulk-box bulk-box-3"></div>
                              <div class="bulk-box bulk-box-4"></div>
                            </div>
                            <div class="productView-form product-form">
                              <form>
                                <div class="productView-group">
                                  <div class="productView-groupTop">
                                    <div class="quantity__group__wrapper">
                                      <div class="productView-quantity quantity__group quantity__group--1 quantity__style--1 clearfix">
                                        <div class="quantity__container">
                                          <button type="button" name="minus" class="minus btn-quantity btn-alert-quantity for-collection-product"></button>
                                          <input class="form-input quantity__input for-collection-product alert-quantity" type="number" name="quantity" min="0" value="${this.quantity}" inputmode="numeric" pattern="[0-9]*" id="stocka-alert-product-quantity-${this.productId}">
                                          <button type="button" name="plus" class="plus btn-quantity btn-alert-quantity for-collection-product"></button>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="productView-action productView-action-2">
                                      <div class="product-form__buttons">
                                        <button type="button" data-value="addToCart" class="product-form__submit button disabled" disabled>${this.text.atc}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              <div class="alert-quantity-error"></div>
                            </div>
                            <div class="productView-see-details">
                              <button class="button button-2" data-value="editDesign" data-fancybox-close>${this.text.edit_design}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`,
            callback: (value) => {
                document.removeEventListener("click", alertClickAddToCartHandler);
                document.removeEventListener("click", alertClickQuantityHandler);
                document.removeEventListener("input", alertChangeQuantityHandler);
                document.removeEventListener("change", alertChangeVariableOptionHandler);
                if (value === "editDesign") this.openDesignBuilder();
            },
            afterInit: function () {
                initBulkBoxes();
                document.addEventListener("click", alertClickAddToCartHandler);
                document.addEventListener("click", alertClickQuantityHandler);
                document.addEventListener("input", alertChangeQuantityHandler);
                document.addEventListener("change", alertChangeVariableOptionHandler);
            }.bind(this)
        });
    }

    getProductOptionsHTML() {
        if (!this.isVariable) return '';
        const options = this.product.productOptions || [];
        const currentVariant = this.getCurrentVariantData();
        return options.map((option, index) => {
            const optionSlug = CustomProductPriceUtils.slugify(option.name);
            const selectedValue = currentVariant.options ? currentVariant.options[index] : '';
            const selectedIndex = option.values.indexOf(selectedValue) ?? 0;
            return `<div class="product-option product-option-${optionSlug}">
                    <p class="option-label">${option.name}</p>
                    <div class="product-option-values">
                    ${option.values.map((value, idx) => {
                return `<label>
                            <input type="radio" name="${option.name}" value="${value}" data-name="${option.name}" ${idx === selectedIndex ? 'checked' : ''}>
                            <span class="text">${value}</span>
                        </label>`;
            }).join('')}
                    </div>
                </div>`;
        }).join('');
    }

    getVariantByOptions(selectedOptions) {
        return this.product.variants.find(variant =>
            variant.options.every((option, index) => option === selectedOptions[index])
        );
    }

    async openDesignBuilder() {
        if (!this.isLogged) {
            setTimeout(() => {
                document.body.classList.add("auth-sidebar-show");
            }, 100);
            return;
        }

        // Per-product flag: hide the Pacdora rollers SVG group for products flagged in admin
        // (metafield custom.hide_pacdora_rollers). CSS: body.pacdora-hide-rollers g[data-v-20ee919c].
        if (this.product?.metafields?.hide_pacdora_rollers === true) {
            document.body.classList.add('pacdora-hide-rollers');
        } else {
            document.body.classList.remove('pacdora-hide-rollers');
        }

        CustomProductPriceUtils.showLoadingIndicator();
        const modelId = parseInt(this.pacdoraData.projectId ?? this.product.pacdoraModelId);
        if (parseInt(CustomProductPriceInstances.lastPacdoraModelId) !== modelId) {
            await this.createNewPacdoraScene(modelId);
        }

        if (!this.hasDesign) {
            await this.setSelectedColor();
        }

        PacdoraPlus.openAdvancedEditor(
            (data) => {
                const productId = Pacdora?.sceneOption?.productId ?? 0
                CustomProductPriceInstances.get(parseInt(productId)).onSaveDesign(data);
            },
            () => {
                const productId = Pacdora?.sceneOption?.productId ?? 0
                CustomProductPriceInstances.get(parseInt(productId)).onCancelDesign(data);
            },
            this.getAdvancedEditorParams()
        );
        PacdoraPlus.$on('editor:face-color-change', async (data) => {
            CustomProductPriceUtils.setPacdoraComponentsColor(data.value);
        });

        setTimeout(() => {
            CustomProductPriceUtils.hideLoadingIndicator();
        }, 500);
    }

    async setSelectedColor() {
        if (!this.productWrapperEl) return;
        const colorPicker = this.productWrapperEl.querySelector('.stocka-color-picker');
        if (colorPicker) {
            const colorPickerHex = colorPicker.dataset.color;
            if (colorPickerHex === undefined) return;
            if (colorPickerHex.length) {
                await PacdoraPlus.setPackageColor('outside', colorPickerHex)
                CustomProductPriceUtils.setPacdoraComponentsColor(colorPickerHex);
                return;
            }
        }
        const activeColorLabel = this.productWrapperEl.querySelector('.color.active');
        if (activeColorLabel) {
            const colorText = activeColorLabel.querySelector('.text').textContent;
            await PacdoraPlus.setPackageColor('outside', colorText)
            CustomProductPriceUtils.setPacdoraComponentsColor(colorText);
        }
    }

    getAdvancedEditorParams() {
        var params = {
            saveScreenshot: true,
            screenshotWidth: 1000,
            exitMode: "save-and-quit",
            appKey: "4e5dc57f3aae54bb",
            renderData: this.getRenderData()
        }
        if (this.pacdoraData.colors.length > 0) {
            params.recommendColorPicker = false;
        }
        console.log(params);
        return params;
    }

    async createNewPacdoraScene(modelId) {
        console.log('reinitializing for modelId:', modelId);
        const createSceneParams = {
            isShowLoading: true,
            isCreatePreview: true,
            packagingColors: this.pacdoraData.colors,
            recommendColors: this.pacdoraData.colors,
            showSize: false,
            productId: this.productId,
            doneBtn: "Save",
        }
        if (this.pacdoraData.colors.length > 0) {
            document.body.classList.add('pacdora-has-custom-colors');
        } else {
            document.body.classList.remove('pacdora-has-custom-colors');
        }
        if (this.pacdoraData.projectId) {
            createSceneParams.templateId = this.pacdoraData.projectId;
        } else {
            createSceneParams.modelId = this.product.pacdoraModelId;
        }
        await PacdoraPlus.createScene(createSceneParams);
        CustomProductPriceInstances.lastPacdoraModelId = modelId;
    }

    setPacdoraColor() {
        const pacdoraColors = this.product.pacdoraColors ?? '';
        const processedColors = pacdoraColors.split(",").map(color => color.trim());
        this.pacdoraData.colors = processedColors.filter(color => /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color));
    }

    getRenderData() {
        const productOptions = this.product.productOptions || [];
        const config = productOptions.reduce((acc, option, index) => {
            if (option.name === 'Title') return acc;
            const currentVariantData = this.getCurrentVariantData();
            acc.push({
                type: option.name + ':',
                selected: currentVariantData?.options?.[index] || option.values[0],
                options: option.values.map(value => ({
                    value
                }))
            });
            return acc;
        }, []);
        return config.length > 0 ? {config} : null;
    }
}

const CustomProductPriceUtils = {
    loaderTimeoutId: null,
    pacdoraTranslations: {
        'he': {
            "Please select the pages you wish to upload": "אנא בחר את הדפים שברצונך להעלות",
            "Upload & Design": "העלה ועצב",
            "Inside": "פנים",
            "Outside": "חוץ",
            "Uploads": "העלאות",
            "Elements": "אלמנטים",
            "Add images": "הוסף תמונות",
            "Supports JPG,PNG,SVG formats": "תומך בפורמטים JPG,PNG,SVG",
            "Selected": "נבחר",
            "piece": "יחידה",
            "uploaded": "הועלה",
            "Material": "חומר",
            "Size": "גודל",
            "Length": "אורך",
            "Width": "רוחב",
            "Height": "גובה",
            "Add JPG,PNG,SVG images Max 20 MB each": "הוסף תמונות JPG,PNG,SVG עד 20 מגה כל אחת",
            "Open": "פתח",
            "Close": "סגור",
            "Face color": "צבע חזית",
            "Show Dimension": "הצג מימדים",
            "Show material": "הצג חומר",
            "Show bleedline": "הצג קו חיתוך",
            "Cut bleedline": "חתוך קו חיתוך",
            "Move bleedline to topmost": "העבר קו חיתוך למעלה",
            "Packaging color": "צבע אריזה",
            "Recommend color": "המלץ על צבע",
            "Design inside": "עצב בפנים",
            "Design outside": "עצב בחוץ",
            "Select tool": "בחר כלי",
            "Hand tool": "כלי יד",
            "Undo": "בטל",
            "Redo": "בצע שוב",
            "Zoom out": "הקטן",
            "Zoom in": "הגדל",
            "Fit": "התאם",
            "Rotation": "סיבוב",
            "View": "תצוגה",
            "Group": "קבץ",
            "unGroup": "בטל קיבוץ",
            "Left": "שמאל",
            "Center": "מרכז",
            "Right": "ימין",
            "Top": "למעלה",
            "Middle": "אמצע",
            "Bottom": "למטה",
            "Justify": "יישר",
            "Alignment": "יישור",
            "Horizontally": "אופקית",
            "Vertically": "אנכית",
            "Distribution": "פיזור",
            "Flip horizontal": "הפוך אופקית",
            "Flip vertical": "הפוך אנכית",
            "Flip": "הפוך",
            "More": "עוד",
            "Duplicate": "שכפל",
            "Delete": "מחק",
            "Lock": "נעל",
            "Bring to front": "העבר לקדמה",
            "Bring forward": "העבר קדימה",
            "Send backward": "העבר אחורה",
            "Send to back": "העבר לאחור",
            "Font": "גופן",
            "Font size": "גודל גופן",
            "Text color": "צבע טקסט",
            "Bold": "מודגש",
            "Italic": "נטוי",
            "Line spacing": "ריווח שורות",
            "Text orientation": "כיוון טקסט",
            "Drag to resize window": "גרור לשינוי גודל החלון",
            "Border style": "סגנון מסגרת",
            "Recommend": "המלץ",
            "Color": "צבע",
            "Unlock": "שחרר",
            "Thickness": "עובי",
            "Transparent": "שקוף",
            "Transparency": "שקיפות",
            "Border radius": "רדיוס פינה",
            "Corner rounding": "עיגול פינות",
            "The uploaded image must not exceed": "התמונה שהועלתה לא תעלה על",
            "Search": "חפש",
            "$": "₪",
            "Download dieline": "הורד קווי חיתוך",
            "Upload design": "העלה עיצוב",
            "Config": "הגדרות",
            "Configure": "הגדר",
            "Buy Now": "קנה עכשיו",
            "pcs": "יח'",
            "Discard": "בטל",
            "Apply": "החל",
            "Packaging Symbols": "סמלי אריזה",
            "Inspirations": "השראות",
            "Social Media": "רשתות חברתיות",
            "Background": "רקע",
            "Shapes": "צורות",
            "Patterns": "דפוסים",
            "Design Online": "עצב אונליין",
            "The current window is maximized": "החלון הנוכחי מוגדל",
            "Unsaved changes": "שינויים שלא נשמרו",
            "All changes will be automatically saved during the editing process.": "כל השינויים יישמרו אוטומטית במהלך העריכה.",
            "Your project is saved automatically while being edited.": "הפרויקט שלך נשמר אוטומטית בזמן העריכה.",
            "All changes saved at ": "כל השינויים נשמרו ב-",
            "saving...": "שומר...",
            "Save & Quit": "שמור וצא",
            "Drag to view the model": "גרור לצפייה במודל"
        },
    },
    translations:   {
        'pieces': "יח",
        'Sample Order': 'הזמנה לדוגמה',
        'Please note: there is a minimum order quantity for this product. You cannot proceed with the purchase using the quantity you selected.': 'שימו לב: קיימת כמות מינימום להזמנה עבור מוצר זה. לא ניתן להמשיך ברכישה בכמות שבחרתם',
        "January": "ינואר",
        "February": "פברואר",
        "March": "מרץ",
        "April": "אפריל",
        "May": "מאי",
        "June": "יוני",
        "July": "יולי",
        "August": "אוגוסט",
        "September": "ספטמבר",
        "October": "אוקטובר",
        "November": "נובמבר",
        "December": "דצמבר"
    },
    getPacdoraInitParams: function (customerId) {
        const params = {
            appId: '5452cd2a25a0554a',
            userId: customerId,
            isDelay: true,
            renderData: {},
            language: 'en'
        }

        if (!window.location.pathname.includes('/en')) {
            /*
            params.renderData.translation = {
                value: JSON.stringify(this.pacdoraTranslations['he'])
            }
            */
            params.language = 'he'
        }
        return params;
    },
    initPacdora: async function (customerId) {
        PacdoraPlus.use(Pacdora);
        await PacdoraPlus.init(this.getPacdoraInitParams(customerId));
        const pacdoraInitializedEvent = new CustomEvent("CustomPacdoraInitialized", {
            detail: {
                message: "Pacdora has been initialized!",
                timestamp: Date.now()
            }
        });
        console.log('Pacdora initialized with customerId:', customerId);
        document.dispatchEvent(pacdoraInitializedEvent);
    },
    setPacdoraComponentsColor: async function (color) {
        const components = await Pacdora.getModelComponentNames();
        const materials = components.reduce((acc, component) => {
            if (component === 'Surface') return acc;
            acc[component] = {color};
            return acc;
        }, {});
        Pacdora.setCustomMaterial(materials, {enablePartNameMatching: true});
    },
    redirectToPreview: function (productId) {
        const productInstance = CustomProductPriceInstances.get(productId);
        if (!productInstance) return;
        const projectId = productInstance.pacdoraData.projectId ?? 0
        if (projectId) {
            window.open('https://stockka.com/pages/view-modal?projectId=' + projectId, "_blank");
        } else {
            console.error("No Project ID found. Cannot redirect.");
        }
    },
    fetchProductDataFromShopify: async function (productHandle) {
        try {
            let fetchUrl = `/products/${productHandle}?view=json`;
            if (window.location.pathname.includes('/en/')) {
                fetchUrl = `/en/${fetchUrl}`;
            }
            const response = await fetch(fetchUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch product data: ${response.status}`);
            }
            return await response.json();

        } catch (error) {
            console.error('Error fetching product data from Shopify:', error);
            return null;
        }
    },
    getOrCreateInstanceByCollectionBtn: async function (btnEl) {
        const productId = parseInt(btnEl.dataset.productId);
        const productWrapperEl = document.getElementById(`collection-product-details-${productId}`);

        let productData = null;

        if (productWrapperEl && productWrapperEl.dataset?.jsonProduct) {
            const productDataString = productWrapperEl.dataset.jsonProduct;
            try {
                productData = JSON.parse(productDataString);
            } catch (e) {
                // do nothing
            }
        }

        if (!productData) {
            const productHandle = btnEl.dataset.handle;
            productData = await this.fetchProductDataFromShopify(productHandle);
            if (!productData) return null;
        }
        return CustomProductPriceInstances.get(productId) || CustomProductPriceInstances.create(productData, false);
    },
    initCollectionProductsListeners: function () {
        document.addEventListener('click', async function (event) {
            if (event.target.matches('.collection-design-btn')) {
                event.preventDefault();
                const productInstance = await CustomProductPriceUtils.getOrCreateInstanceByCollectionBtn(event.target);
                if (!productInstance) return;
                productInstance.openDesignBuilder();
            }
            if (event.target.matches('.collection-atc-btn')) {
                event.preventDefault();
                const productInstance = await CustomProductPriceUtils.getOrCreateInstanceByCollectionBtn(event.target);
                if (!productInstance) return;
                productInstance.addToCartByQty(0);
            }
        });
    },
    showLoadingIndicator: () => {
        const loaderHtml = `<div id="custom-loader"><div id="loader-container">
                <svg id="loader" width="215" height="215" viewBox="0 0 400 400" style="overflow: visible;">
                    <circle id="loader-bg" cx="200" cy="200" r="195" fill="rgba(255,255,255,0.7)"/>
                    <circle id="loader-bg-circle" cx="200" cy="200" r="195" stroke="rgba(16, 6, 238, 0.34)" stroke-width="3" fill="none"/>
                    <circle id="loader-progress" cx="200" cy="200" r="195" stroke="#1006EE" stroke-width="12" fill="none" stroke-linecap="butt" stroke-dasharray="1225" stroke-dashoffset="1225" transform="rotate(-90 200 200)" style="stroke-width:24px"/>
                    <text id="loader-text" x="200" y="215" text-anchor="middle" font-size="48" fill="#333" font-family="Arial, sans-serif">0%</text>
                </svg>
            </div></div>`;
        document.body.insertAdjacentHTML('beforeend', loaderHtml);

        const progressCircle = document.getElementById('loader-progress');
        const text = document.getElementById('loader-text');
        const circumference = 2 * Math.PI * 195;
        let percent = 0;

        function animateLoader() {
            if (percent > 100) return;
            const offset = circumference - (percent / 100) * circumference;
            progressCircle.setAttribute('stroke-dashoffset', offset);
            text.textContent = percent + '%';
            percent++;
            this.loaderTimeoutId = setTimeout(animateLoader, 20);
        }

        animateLoader();
    },
    hideLoadingIndicator: () => {
        if (this.loaderTimeoutId) {
            clearTimeout(this.loaderTimeoutId);
            this.loaderTimeoutId = null;
        }
        const loadingDiv = document.getElementById("custom-loader");
        if (loadingDiv) loadingDiv.remove();
    },
    getTranslations: function (word) {
        if (window.location.pathname.includes('/en')) return word;
        if (this.translations[word]) {
            return this.translations[word];
        }
        return word;
    },
    translateDate: function (dateString) {
        if (!dateString || typeof dateString !== 'string') {
            return dateString;
        }
        const pieces = dateString.trim().split(' ');
        if (pieces.length !== 2) {
            return dateString;
        }
        const [month, day] = pieces;
        const translatedMonth = CustomProductPriceUtils.getTranslations(month);

        return `${day} ${translatedMonth}`;
    },
    slugify: function (text = '') {
        if (typeof text !== 'string') return '';
        return (text
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-z0-9\s-_]/g, "")
                .trim()
                .replace(/\s+/g, "-")
                .replace(/^-+|-+$/g, "")
                .replace(/^[^a-z]+/, "")
        );
    },
    show: {
        alert: (optsParams) => {
            const opts = Object.assign(
                {
                    mainClasses: "fc-content stocka-alert",
                    content: "",
                    callback: null,
                    afterInit: null
                },
                optsParams || {}
            );

            $.fancybox.open({
                type: "html",
                src:
                    `<div class="${opts.mainClasses}">` +
                    '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="Close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button>' +
                    opts.content +
                    "</div>",
                opts: {
                    animationDuration: 300,
                    modal: true,
                    baseTpl:
                        `<div class="fancybox-container fc-container" role="dialog" tabindex="-1">` +
                        '<div class="fancybox-bg"></div>' +
                        '<div class="fancybox-inner">' +
                        '<div class="fancybox-stage"></div>' +
                        "</div>" +
                        "</div>",
                    afterClose: function (instance, current, e) {
                        const button = e ? e.target || e.currentTarget : null;
                        const value = button ? $(button).data("value") : 0;
                        if (typeof opts.callback === "function") {
                            opts.callback(value);
                        }
                    },
                },
            });
            if (typeof opts.afterInit === "function") {
                opts.afterInit();
            }
        },
    }
}

const CustomProductPriceInstances = {
    lastPacdoraModelId: null,
    productPriceInstances: new Map(),
    create: (product, isMain = false) => {
        const instance = new CustomProductPrice(product, isMain);
        CustomProductPriceInstances.productPriceInstances.set(product.id, instance);
        return instance;
    },
    get: (productId) => {
        return CustomProductPriceInstances.productPriceInstances.get(productId);
    },
    remove: (productId) => {
        CustomProductPriceInstances.productPriceInstances.delete(productId);
    },
    clear: () => {
        CustomProductPriceInstances.productPriceInstances.clear();
    }
}

document.addEventListener('CustomPacdoraInitialized', () => {
    CustomProductPriceUtils.initCollectionProductsListeners();
});
